function getLanguage() {
    const language = window.location.pathname.split("/")[1];

    if ('fr' === language) {
        return 'fr';
    } else {
        return 'en';
    }
}

export const language = getLanguage();
